export const listInvites = /* GraphQL */ `
  query ListInvites(
    $filter: ModelInviteFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listInvites(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        code
        userID
        ln
        fn
        name @client
        user {
          id
          email
          sub
        }
        role
        status
        entityID
        entity {
          id
          alias
        }
        createdAt
        updatedAt
        invitedAt @client
      }
      nextToken
    }
  }
`;

export const deleteInvite = /* GraphQL */ `
  mutation DeleteInvite(
    $input: DeleteInviteInput!
    $condition: ModelInviteConditionInput
  ) {
    deleteInvite(input: $input, condition: $condition) {
      id
    }
  }
`;

export const getInvite = /* GraphQL */ `
  query GetInvite($id: ID!) {
    getInvite(id: $id) {
      id
      code
      fn
      ln
      userID
      user {
        id
        email
        sub
      }
      role
      entityID
      entity {
        id
        alias
        name
      }
      validDays
      status
      createdAt
      updatedAt
    }
  }
`;

export const updateInvite = /* GraphQL */ `
  mutation UpdateInvite(
    $input: UpdateInviteInput!
    $condition: ModelInviteConditionInput
  ) {
    updateInvite(input: $input, condition: $condition) {
      id
      code
      userID
      role
      fn
      ln
      entityID
      status
      validDays
      status
      createdAt
      updatedAt
    }
  }
`;

export const listEntities = /* GraphQL */ `
  query ListEntities(
    $filter: ModelEntityFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listEntities(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        alias
      }
      nextToken
    }
  }
`;

export const userByEmail = /* GraphQL */ `
  query UserByEmail(
    $email: AWSEmail!
    $sub: ModelIDKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelUserFilterInput
    $limit: Int
    $nextToken: String
  ) {
    userByEmail(
      email: $email
      sub: $sub
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        sub
        email
      }
      nextToken
    }
  }
`;

export const createUser = /* GraphQL */ `
  mutation CreateUser(
    $input: CreateUserInput!
    $condition: ModelUserConditionInput
  ) {
    createUser(input: $input, condition: $condition) {
      id
      email
    }
  }
`;

export const createInvite = /* GraphQL */ `
  mutation CreateInvite(
    $input: CreateInviteInput!
    $condition: ModelInviteConditionInput
  ) {
    createInvite(input: $input, condition: $condition) {
      id
      code
      fn
      ln
      userID
      user {
        id
      }
      role
      entityID
      createdAt
      updatedAt
    }
  }
`;

export const fragment = /* GraphQL */ `
  fragment NewInvite on Invite {
    id
  }
`;
